const PL = {
  locale: "fr",
  messages: {
    flowScene: {
      filters: {
        flowTypes: {
          truck: "PL",
        },
      },
      flowType: {
        truck: "{count, plural, one {PL} other {PL}}",
        short_truck: "PL",
      },
    },
    indicatorsScene: {
      table: {
        header: {
          truck: "PL",
          trucks: "PL",
        },
      },
    },
  },
};

export default PL;
